<template>
    <div class="form-group">
        <label for="months-control" v-if="label">Mes <span class="required-check-mark" v-if="!!required">*</span></label>
        <select
            class="form-control"
            name="months-control"
            id="months-control"
            @change="({target}) => $emit('input', parseInt(target.value))"
            v-bind="$attrs"
            v-on="$listeners"
        >
            <option value="" v-if="placeholder">Mes</option>
            <option value="" v-else>-- Seleccione --</option>
            <option v-for="month in months" :key="month.id" :value="month.id" :selected="month.id === value">{{ month.name }}</option>
        </select>
        <span class="field-error" v-if="!!hasError">{{ errorMessage }}</span>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    inheritAttrs: false,
    props: {
        placeholder: {
            type: Boolean,
            default: false
        },
        label: {
            type: Boolean,
            default: true
        },
        errorMessage: {
            type: String,
            default: ''
        },
        hasError: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        },
        value: {}
    },
    computed: {
        ...mapGetters(['months'])
    }
}
</script>